<div class="header">
  <h2>{{ title }}</h2>
  @if (urlPath) {
    <a [routerLink]="[urlPath]"> > {{ urlText }}</a>
  }
</div>
